import { severidades } from "constants/common/formConstants"
import { classes } from "constants/common/formConstants"
import { tipoIncidentes } from "constants/common/formConstants"
import { locais } from "constants/common/formConstants"
import PersonIcon from '@mui/icons-material/Person';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import WarningIcon from '@mui/icons-material/Warning';
import ArchiveIcon from '@mui/icons-material/Archive';
import EmailIcon from '@mui/icons-material/Email';
import CategoryIcon from '@mui/icons-material/Category';
import NotesIcon from '@mui/icons-material/Notes';
import GroupsIcon from '@mui/icons-material/Groups';
import CallIcon from '@mui/icons-material/Call';
import PersonRemoveAlt1Icon from '@mui/icons-material/PersonRemoveAlt1';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import CampaignIcon from '@mui/icons-material/Campaign';
import { comunicacao } from "./comunicacao";


export const newAcidenteForm = (users, disabled) => {
    const styles = { marginTop: "-5px", height: "30px", width: "20px", color: "#7392B7" }

    return [
        {
            fieldId: 'reportado_por',
            required: true,
            label: 'Reportado por:',
            flex: true,
            type: 'select',
            disabled,
            options:  users,
            icon: <PersonIcon style={styles} />
        },
        {
            fieldId: 'local_reporter',
            required: true,
            label: 'Afecto em:',
            flex: true,
            type: 'select',
            options: locais,
            icon: <LocationOnIcon style={styles} />
        },
        {
            fieldId: 'dataAcontecimento',
            required: true,
            label: 'Data:',
            flex: true,
            type: 'date',
            icon: <CalendarMonthIcon style={styles} />
        },
        {
            fieldId: 'local',
            required: true,
            label: 'Onde Ocorreu:',
            flex: true,
            type: 'select',
            options: locais,
            icon: <LocationOnIcon style={styles} />
        },
        {
            fieldId: 'descricao',
            required: true,
            label: 'O que aconteceu:',
            placeholder: "De forma resumida, o que aconteceu?",
            flex: false,
            type: 'text',
            icon: <NotesIcon style={styles} />
        },
        {
            fieldId: 'circunstancias',
            required: false,
            label: 'Aconteceu em que circunstancias?:',
            placeholder: "De forma detalhada, explique o que aconteceu",
            flex: false,
            multiLine: true,
            rows: 4,
            type: 'text',
            icon: <NotesIcon style={styles} />
        },
        {
            fieldId: 'tipo_incidente',
            required: true,
            label: 'Tipo de acidente:',
            flex: true,
            type: 'select',
            options: tipoIncidentes,
            icon: <WarningIcon style={styles} />
        },
        {
            fieldId: 'severidade',
            required: true,
            label: 'Nível de severidade:',
            flex: true,
            type: 'select',
            options: severidades,
            icon: <WarningIcon style={styles} />
        },
        {
            fieldId: 'planoDeAccao',
            required: false,
            label: 'Plano de acção:',
            placeholder: "De forma resumida, como podemos resolver isso",
            multiLine: true,
            rows: 4,
            type: 'text',
            icon: <NotesIcon style={styles} />
        },
        {
            fieldId: 'com_arquivada',
            required: false,
            label: 'Comunicação arquivada?',
            flex: true,
            type: 'radio',
            colapse: true,
            icon: <ArchiveIcon style={styles} />,
            radioFlex: true,
            colapseInput: {
                fieldId: 'com_arquivada_data',
                label: 'Quando foi arquivada?',
                required: true,
                flex: true,
                type: 'date',
                icon: <CalendarMonthIcon style={styles} />
            },
            options: [
                {
                    label: "Sim",
                    value: "1"
                }, {
                    label: "Não",
                    value: "2"
                }
            ]
        },
        {
            fieldId: 'com_arquivada_cta',
            required: false,
            label: 'Comunicação enviada ao conselho administrativo?',
            flex: true,
            type: 'radio',
            colapse: true,
            radioFlex: true,
            icon: <EmailIcon style={styles} />,
            colapseInput: {
                fieldId: 'com_arquivada_cta_data',
                label: 'Quando foi enviada?',
                required: true,
                flex: true,
                type: 'date',
                icon: <CalendarMonthIcon style={styles} />
            },
            options: [
                {
                    label: "Sim",
                    value: "1"
                }, {
                    label: "Não",
                    value: "2"
                }
            ]
        },
        {
            fieldId: 'classe',
            required: true,
            label: 'Classe do acidene:',
            flex: false,
            type: 'radio',
            options: classes,
            icon: <CategoryIcon style={styles} />
        },
        {
            fieldId: 'medidas_imediatas',
            required: true,
            label: 'Acção Imediata:',
            placeholder: "O que foi que fizeste logo após identificar o near miss?",
            flex: false,
            type: 'text',
            icon: <NotesIcon style={styles} />
        },
        {
            fieldId: 'autores',
            required: true,
            label: 'Autores do Acidente:',
            placeholder: "Autores do acidente",
            flex: false,
            multiLine: true,
            rows: 4,
            type: 'text',
            icon: <GroupsIcon style={styles} />
        },
        {
            fieldId: 'causas_preliminares',
            required: false,
            label: 'Causas preliminares:',
            placeholder: "Quais são as causas preliminares do acidente?",
            flex: false,
            multiLine: true,
            rows: 4,
            type: 'text',
            icon: <NotesIcon style={styles} />
        },
        {
            label: 'Comunicação',
            fieldId: "comunicacao",
            required: false,
            type: 'bubles',
            icon: <CallIcon style={styles} />,
            note: "**Podes clicar em pelo menos uma opção de cada categoria",
            sections: comunicacao
        },
        {
            title: 'Danos humanos:',
            flex: false,
            type: 'table',
            icon: <PersonRemoveAlt1Icon style={styles} />,
            inputType: 'number',
            cols: [
                {
                    label: "Feridos",
                    id: "feridos"
                },
                {
                    label: "Fatalidades",
                    id: "fatalidades"
                },
                {
                    label: "Total",
                    id: "total"
                }
            ],
            rows: [
                {
                    label: "3ªs Partes",
                    id: "terceiros"
                },
                {
                    label: "Contratados",
                    id: "contratados"
                },
                {
                    label: "GIMTL",
                    id: "samcol"
                },
                {
                    label: "Total",
                    id: "totalVertical"
                }
            ]
        },
        {
            label: 'Danos materiais / à imagem',
            type: 'inputGroup',
            icon: <RemoveCircleIcon style={styles} />,
            groups: [
                {
                    title: "Danos Materiais:",
                    fields: [
                        {
                            fieldId: 'dm_samcol',
                            label: 'Samcol instalações/equipamentos:',
                            placeholder: "Quais instalacoes/equipamentos sofreram?",
                            flex: false,
                            multiLine: true,
                            rows: 2,
                            type: 'text',
                        },
                        {
                            fieldId: 'dm_terceiros',
                            label: '3ª Parte "Terceiros":',
                            placeholder: "Terceiros que sofreram",
                            flex: false,
                            multiLine: true,
                            rows: 2,
                            type: 'text',
                        },
                        {
                            fieldId: 'dm_contratados',
                            label: 'Contratados:',
                            placeholder: "Contratados que sofreram",
                            flex: false,
                            multiLine: true,
                            rows: 2,
                            type: 'text',
                        },
                    ]
                },
                {
                    title: "Danos à Imagem:",
                    fields: [
                        {
                            fieldId: 'di_samcol',
                            label: 'Imagem da SAMCOL:',
                            placeholder: "Imagem da SAMCOL",
                            flex: false,
                            multiLine: true,
                            rows: 2,
                            type: 'text',
                        },
                        {
                            fieldId: 'di_outros',
                            label: 'Outros:',
                            placeholder: "Outros",
                            flex: false,
                            multiLine: true,
                            rows: 2,
                            type: 'text',
                        },
                        {
                            fieldId: 'di_imprensa',
                            label: 'Imprensa',
                            placeholder: "Imprensa",
                            flex: false,
                            multiLine: true,
                            rows: 2,
                            type: 'text',
                        },
                    ]
                }
            ]
        },
        {
            "fieldId": "toNotify",
            "required": false,
            "label": "Para conhecimento:",
            "flex": false,
            "type": "multiSelect",
            "options": users,
            icon: <CampaignIcon style={{ ...styles, fontSize: "35px" }} />
        }
    ]
}